import type {CommonProps} from './types';

export default ({color = 'currentColor', size = 32, ...rest}: CommonProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={size}
    width={size}
    viewBox="0 0 32 32"
    {...rest}
  >
    <path
      fill={color}
      d="M30.83 26.67L18.36 2.87a2.67 2.67 0 0 0-4.72 0L1.17 26.67a2.67 2.67 0 0 0 2.37 3.9h24.92a2.67 2.67 0 0 0 2.37-3.9zM14.67 11.23a1.33 1.33 0 0 1 2.66 0v8a1.33 1.33 0 0 1-2.66 0v-8zm1.4 15.35h-.04c-1.1 0-1.99-.87-2.03-1.96-.04-1.09.8-2 1.9-2.04h.07c1.09 0 1.99.86 2.03 1.95.04 1.09-.8 2-1.89 2.05h-.04z"
    />
  </svg>
);
